import React from 'react'
import { Box } from 'reactjs-admin-lte'
import './report.css'
import { InputGroup, FormGroup, FormControl, Form, Row, Col, Panel, ButtonToolbar, Button } from 'react-bootstrap'
import { Checkbox } from 'react-icheck'
import Select from 'react-select'
import 'icheck/skins/all.css'
// import moment from 'moment'
import FontAwesome from 'react-fontawesome'
// import PropTypes from 'prop-types'
import ReportStore from '../../stores/ReportStore'
import {connect} from 'react-redux'
/* const minPrice = 1
const maxPrice = 100000
const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
}
const getRandomDate = (days) => moment().subtract(days, 'days').calendar()
const getRandomText = () => Math.random().toString(36).substr(2, 5)

const createMockCostList = (shopId) => (
  new Array(4).fill(null).map((value, index) => {
    const theShopId = getRandomInt(1, 4) + ''
    return Object.assign({},
      {
        itemnum: getRandomInt(1, 5000),
        title: getRandomText(),
        quantity: getRandomInt(1, 5),
        amount: getRandomInt(minPrice, maxPrice),
        shopId: theShopId,
        shopName: getRandomText(),
        checked: theShopId === shopId
      })
  })
)

const createMockNonMatchShopIdList = () => (
  new Array(4).fill(null).map((value, index) => {
    return Object.assign({},
      {
        itemnum: getRandomInt(1, 5000),
        title: getRandomText(),
        quantity: getRandomInt(1, 5),
        amount: getRandomInt(minPrice, maxPrice),
        shopId: getRandomInt(2, 3) + '',
        shopName: getRandomText(),
        checked: false
      })
  })
)

const createMockPOList = (shopId) => (
  new Array(4).fill(null).map((value, index) => {
    return Object.assign({},
      {
        // checked: false,
        issuedDate: getRandomDate(getRandomInt(1, 100)),
        workNo: Math.random().toString(36).substr(2, 5),
        licensePlateNo: Math.random().toString(36).substr(2, 5),
        brand: 'TOYOTA',
        model: 'CAMRY',
        mileage: getRandomInt(minPrice, maxPrice),
        customer: Math.random().toString(36).substr(2, 5),
        amount: getRandomInt(minPrice, maxPrice),
        note: '',
        status: '0',
        detail: {
          labors: createMockCostList(shopId),
          parts: createMockCostList(shopId)
        }
      })
  }).concat(
    Object.assign({},
      {
        // checked: false,
        issuedDate: getRandomDate(getRandomInt(1, 100)),
        workNo: Math.random().toString(36).substr(2, 5),
        licensePlateNo: Math.random().toString(36).substr(2, 5),
        brand: 'TOYOTA',
        model: 'CAMRY',
        mileage: getRandomInt(minPrice, maxPrice),
        customer: Math.random().toString(36).substr(2, 5),
        amount: getRandomInt(minPrice, maxPrice),
        note: '',
        status: '0',
        detail: {
          labors: createMockNonMatchShopIdList(),
          parts: createMockNonMatchShopIdList()
        }
      })
    )
) */

/* const sampleData = {
  // checked: false,
  issuedDate: '27/03/2560',
  workNo: 'SR304.0692/2560',
  licensePlateNo: 'กข751',
  brand: 'TOYOTA',
  model: 'CAMRY',
  mileage: '',
  customer: 'กรุงเทพประกันภัย',
  amount: '18200',
  note: '',
  status: '0',
  detail: {
    labors: [
      {
        title: 'กาบประตูคิ้วข้างหน้าขวา',
        amount: '1000',
        shopId: '1xxx',
        shopName: 'ร้านอะไร'
      },
      {
        title: 'ซับในบันได ขวา',
        amount: '3200',
        shopId: '1xxx',
        shopName: 'ร้านอะไร'
      }
    ],
    parts: [
      {
        title: 'กระจกมองหลัง ห้องโดยสาร',
        quantity: '1',
        amount: '1000',
        shopId: '1xxx',
        shopName: 'ร้านอะไร',
        checked: false
      },
      {
        title: 'คลิ๊ปรองกระจกบังลมหน้า',
        quantity: '1',
        amount: '2000',
        shopId: '2xxx',
        shopName: 'ร้านล้าน',
        checked: false
      }
    ]
  }
} */

class SelectParts extends React.Component {
  constructor(props) {
    super(props)
    let {messages} = this.props
    this.headerTitles = {
      added_date: messages['Date'],
      work_no: messages['Work No'],
      car_registration_no: messages['Car Registration'],
      // brand: 'ยี่ห้อ',
      // model: 'รุ่น',
      car_detail: messages['Model'],
      owner_name: messages['Customer'],
      amount: messages['Value'],
      // note: 'หมายเหตุ',
      status: messages['Status'],
      partList: messages['Parts Price List']
      // detail: {
      //   labors: 'รายการค่าแรง',
      //   parts: 'รายการค่าอะไหล่'
      // }
    }

    this.state = {
      filter: 'car_registration_no',
      query: '',
      data: [{ partList: [] }],
      purChaseOrders: typeof this.props.purChaseOrders !== 'undefined'
        ? this.props.purChaseOrders
        : []
    }
    this.loadUnPurchasedWork()
  }

  setupState(dataByShopId) {
    //console.log('setupState',dataByShopId)
    const newData = dataByShopId.map((unPurchasedWorkItem) => {
      unPurchasedWorkItem.partList.forEach((partItem) => {
        partItem.checked = this.isPartItemInPurchaseOrderList(partItem)
      })
      return unPurchasedWorkItem
    })

    /* const nonChecked = newData.every((unPurchasedWorkItem) => {
      return unPurchasedWorkItem.partList.every((partItem) => !partItem.checked)
    })

    if (nonChecked) {
      this.setState({
        data: newData.map((unPurchasedWorkItem) => {
          unPurchasedWorkItem.partList.forEach((partItem) => {
            partItem.checked = partItem.shop_id === this.props.shopId
          })
          return unPurchasedWorkItem
        })
      })
      return
    } */

    this.setState({
      data: newData
    })
  }

  loadUnPurchasedWork() {
    if (typeof this.props.shopId === 'undefined') return
    const { query, cat ,filter} = this.state
    ReportStore.loadUnPurchaseWork(query, filter, (result) => {
      this.setupState(result.data)
    })
  }

  renderHeader() {
    if (typeof this.state.data === 'undefined') return null
    // if (this.state.data === null) return null

    const ths = Object.keys(this.headerTitles).map((k, i) => (
      k !== 'partList'
        ? <th key={i + 1} className='fit text-center'>{this.headerTitles[k]}</th>
        : null
    ))

    return (
      <thead>
        <tr>{ths}</tr>
      </thead>
    )
  }

  onPartItemSelect(unPurchasedWorkItemIndex, partItemIndex, e) {
    const newData = [...this.state.data]
    newData[unPurchasedWorkItemIndex].partList[partItemIndex].checked = e.target.checked
    // console.log('check',newData)
    this.setState({ data: newData })
  }

  onAllPartItemSelect(unPurchasedWorkItemTarget, e) {
    const newData = this.state.data.map((unPurchasedWorkItem) => {
      if (unPurchasedWorkItem.work_no !== unPurchasedWorkItemTarget.work_no)
        return unPurchasedWorkItem

      const newPartList = unPurchasedWorkItem.partList.map((partItem) => {
        partItem.checked = e.target.checked
        return partItem
      })
      unPurchasedWorkItem.partList = newPartList
      return unPurchasedWorkItem
    })
    this.setState({ data: newData })
  }

  isPartItemInPurchaseOrderList(partItem) {
    if (this.state.purChaseOrders.length === 0) return
    return (
      this.state.purChaseOrders.some((item) => {
        return item.detail === partItem.detail && item.work_no === partItem.work_no
        /* if (typeof item.shop_id !== 'undefined')
          return item.detail === partItem.detail && item.work_no === partItem.work_no
        return false */
      })
    )
  }

  renderDetail(unPurchasedWorkItem, unPurchasedWorkItemIndex) {
    let {messages} = this.props
    if (this.state.data.length === 0) return null
    const createPartItemCheckboxes = (partList) => {
      const lis = partList.map((partItem, partItemIndex) => {
        const liColor = this.props.shopId === partItem.shop_id ? 'green' : ''
        const stockText = partItem.stock_flag*1===1?'('+messages['Items In Stock']+')':''
        const displayValue = `${partItem.detail} ${messages['Quantity']}  ${partItem.quantity} ${messages['Item']} ${stockText}`
        const theSpan = (
          <span className='part-item'>
            {displayValue}
          </span>
        )

        return (
          <li
            key={partItemIndex}
            style={{ color: liColor }}
          >
            <Checkbox
              checkboxClass="icheckbox_square-blue"
              increaseArea="20%"
              label={theSpan}
              checked={partItem.checked}
              onChange={this.onPartItemSelect.bind(this, unPurchasedWorkItemIndex, partItemIndex)}
            />
          </li>
        )
      })


      return (
        <ul style={{ padding: '0', margin: '0' }}>
          <li><b>{messages['Parts Item']}</b></li>
          <li>
            <Checkbox
              checkboxClass="icheckbox_square-blue"
              increaseArea="20%"
              label={
                <span style={{ paddingLeft: '15px' }}>
                  {messages['Select All']}
                </span>
              }
              checked={partList.every((item) => item.checked)}
              onChange={this.onAllPartItemSelect.bind(this, unPurchasedWorkItem)}
            />
          </li>
          {lis}
        </ul>
      )
    }

    return (
      <Panel style={{ marginBottom: '0px', paddingBottom: '0px' }}>
        <Row>
          <Col md={6}>
            {createPartItemCheckboxes(unPurchasedWorkItem.partList)}
          </Col>
        </Row>
      </Panel>
    )
  }

  /* onWorkOrderChecked(workOrderItemTarget, e) {
    const newData = this.state.data.map((workOrderItem) => {
      if (workOrderItem.workNo !== workOrderItemTarget.workNo) return workOrderItem

      const partsMatchedShopId = workOrderItemTarget.detail.parts.filter((partItem) =>
        (partItem.shopId === this.props.shopId)
      )
      if (partsMatchedShopId.length === 0) {
        return workOrderItem
      }

      workOrderItemTarget.checked = !workOrderItem.checked
      const newParts = workOrderItemTarget.detail.parts.map((partItem) => {
        if (partItem.shopId === this.props.shopId)
          partItem.checked = e.target.checked
        else
          partItem.checked = false
        return partItem
      })
      workOrderItemTarget.detail.parts = newParts
      return workOrderItemTarget
    })

    this.setState({ data: newData })
  } */

  renderRows() {
    if (this.state.data.length === 0) return null
    const { query, filter } = this.state

    return this.state.data.map((unPurchasedWorkItem, pid) => {
      if (query.length > 0
        && filter === 'car_registration_no'
        && !unPurchasedWorkItem.car_registration_no.toLowerCase().includes(query.toLowerCase())
      )
        return
      if (query.length > 0
        && filter === 'work_no'
        && !unPurchasedWorkItem.work_no.toLowerCase().includes(query.toLowerCase())
      )
        return

      const tds = Object.keys(this.headerTitles).filter((title) => title !== 'partList')
        .map((k, index) =>
          <td key={index} className='fit text-center'>
            {unPurchasedWorkItem[k]}
          </td>
        )

      return (
        [
          <tr>{tds}</tr>,
          <tr key={pid}>
            <td colSpan={Object.keys(this.headerTitles).length}>
              {this.renderDetail(unPurchasedWorkItem, pid)}
            </td>
          </tr>
        ]
      )
    })
  }

  onSavePartItemsClick(e) {
    /* const purChaseOrderItemsNoShopId =
      this.state.purChaseOrders.filter((purChaseOrderItem) =>
        typeof purChaseOrderItem.shop_id === 'undefined')
        .filter((purChaseOrderItem) => purChaseOrderItem.detail !== '') */

    /* const purChaseOrderItemsWithShopId =
      this.state.data.reduce((acc, unPurchasedWorkItem) => {
        const selectedPartLists =
          unPurchasedWorkItem.partList.filter((partItem) => partItem.checked)
        if (selectedPartLists.length > 0)
          selectedPartLists.forEach((partItem) => partItem.car_registration_no = unPurchasedWorkItem.car_registration_no)

        return acc.concat(selectedPartLists)
      }, [])
    const newPurChaseOrders = purChaseOrderItemsNoShopId.concat(purChaseOrderItemsWithShopId) */

    // const poWithoutWorkNo =
    //   this.state.purChaseOrders.filter((purChaseOrderItem) => purChaseOrderItem.work_no === '')
    //     .filter((purChaseOrderItem) => purChaseOrderItem.detail !== '')
    const poWithoutWorkNo =
      this.state.purChaseOrders.filter((purChaseOrderItem) => purChaseOrderItem.detail !== '')

    const selectedPOs =
      this.state.data.reduce((acc, unPurchasedWorkItem) => {
        const selectedPartLists =
          unPurchasedWorkItem.partList.filter((partItem) => partItem.checked)
        if (selectedPartLists.length > 0)
          selectedPartLists.forEach((partItem) => partItem.car_registration_no = unPurchasedWorkItem.car_registration_no)

        return acc.concat(selectedPartLists)
      }, [])
    const newPurChaseOrders = poWithoutWorkNo.concat(selectedPOs)
    this.props.onSavePartItemsClick(newPurChaseOrders)
  }

  onFilterChange(e) {
    let filter = e ? e.value : ''
    this.setState({ filter: filter })
  }

  onSearchKeyPress(target) {
    if (target.charCode == 13) {
      // console.log('enter ')
      // this.setState({
      //   query: target.value
      // })

       let { query, filter } = this.state
      ReportStore.loadUnPurchaseWork(query, filter, (result) => {
         this.setupState(result.data)
     })

      // ReportStore.loadReportWorkQuery(query, filter, (result) => {
      //Laod OK
      // this.setState({ data: result.data, pageCount: result.data_count / itemPerPage })
      // })
    }
  }

  onQueryChange(e) {
    this.setState({ query: e.target.value })
  }

  onSearchClick() {
    const { query,cat, filter } = this.state
    ReportStore.loadUnPurchaseWork( query, filter, (result) => {
      this.setupState(result.data)
    })
    //TODO find a work
  }

  renderToolBar() {
    let {messages} = this.props
    const filterOptions = [
      { value: 'car_registration_no', label: messages['Car Registration'] },
      { value: 'work_no', label: messages['Work No'] },
    ]

    return (
      <Form inline>
        <FormGroup
          controlId="formControlsSelectMultiple"
          className="pull-left"
          style={{
            width: '100%'
          }}
        >
          <FormGroup style={{ width: '20%' }}>
            <Select options={filterOptions} value={this.state.filter}
              placeholder={messages['Select Category In Search']}
              onChange={this.onFilterChange.bind(this)}
              clearable={false}
            />
          </FormGroup>
          <FormGroup>
            <InputGroup>
              <FormControl
                type="text"
                value={this.state.query}
                placeholder=""
                onKeyPress={this.onSearchKeyPress.bind(this)}
                onChange={this.onQueryChange.bind(this)}
              />
              <InputGroup.Button>
                <Button
                  className='btn-flat'
                  onClick={this.onSearchClick.bind(this)}
                >
                  <FontAwesome name='search' />
                </Button>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>
        </FormGroup>
      </Form>

    )
  }

  render() {
    let {messages} = this.props
    return (
      <Box>
        <Box.Header>
          {this.renderToolBar()}
        </Box.Header>
        <Box.Body>
          <div className='display-overflow'>
            <table className='table table-responsive table-hover table-bordered-solid'>
              {this.renderHeader()}
              <tbody>
                {this.renderRows()}
              </tbody>
            </table>
          </div>
        </Box.Body>
        <Box.Footer>
          <ButtonToolbar className='pull-right'>
            <Button
              bsStyle='primary'
              onClick={this.onSavePartItemsClick.bind(this)}
            >
              <FontAwesome name='shopping-cart' />&nbsp;{messages['Add Order']}
            </Button>
            <Button onClick={this.props.onClose}>
              <FontAwesome name='close' />&nbsp;{messages['Cancel']}
            </Button>
          </ButtonToolbar>
        </Box.Footer>
      </Box>
      // <div>
      //   <Row>
      //     <Col md={6}>
      //       <ButtonToolbar>
      //         <Button onClick={this.onSendPartItemDataClick.bind(this)}>บันทึก</Button>
      //       </ButtonToolbar>
      //     </Col>
      //   </Row>
      //   <Row>

      //   </Row>
      // </div>
    )
  }
}
SelectParts.defaultProps = {
  shopId: '3'
}
export default connect(
  (state) => ({messages: state.message.view.po.SelectParts}),null,null,{withRef:true}
)(SelectParts);



// WEBPACK FOOTER //
// ./src/view/po/SelectParts.js